export default "__VITE_ASSET__BzQtvgYM__"